import { Injectable, inject } from '@angular/core';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import type { SpanExporter } from '@opentelemetry/sdk-trace-base';

import { MtcExporterUtilsService } from '../mtc-exporter-utils.service';

@Injectable()
export class MtcSpanExporter extends OTLPTraceExporter implements SpanExporter {
    constructor() {
        const mtcExporter = inject(MtcExporterUtilsService);
        const baseUrl = mtcExporter.getEndpointBaseUrl();
        const url = baseUrl ? `${baseUrl}/v1/traces` : undefined;

        super({
            url,
            concurrencyLimit: 10,
            headers: mtcExporter.headers
        });
    }
}
